let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("62CNd")).then(() => parcelRequire('bv20m'));